import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class PaginationHelperService {
    public detectEndOfScrollRaw(distance: number, rowSize: number, offsetCount: number, callback: () => void): void {
        if (distance <= offsetCount * rowSize) {
            callback();
        }
    }
}